export default "__VITE_ASSET__BhPjFht1__"